import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Recibís el material en formato PDF de alta calidad para ver desde celular, tablet o computadora, y también podés imprimir las partes que quieras.'
}, {
  q: '¿Esto reemplaza terapia o acompañamiento profesional?',
  a: 'No. Es un recurso educativo y práctico para el hogar. No reemplaza evaluación ni tratamiento profesional.'
}, {
  q: '¿Sirve solo si mi hijo tiene diagnóstico?',
  a: 'No. También puede ayudarte si tu hijo tiene dificultades de atención, desregulación, berrinches intensos o problemas con rutinas aunque no tenga diagnóstico formal.'
}, {
  q: '¿Voy a recibir acceso inmediato?',
  a: 'Sí. Una vez completada la compra, recibís acceso inmediato al material.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-ocean-blue" data-id="element-25">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-28">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-30">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-ocean-teal focus:ring-inset" aria-expanded={openIndex === index} data-id="element-31">
                <span className="font-bold text-gray-900 pr-4" data-id="element-32">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-ocean-teal shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-33" />
              </button>

              <AnimatePresence data-id="element-34">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-36">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}